<template>
  <div class="BgSidebarDropdown">
    <input
      v-if="searchEnabled"
      v-model="search"
      type="text"
      placeholder="Search..."
      class="BgSidebarDropdown__search"
    />

    <div class="BgSidebarDropdown__scroll">
      <router-link
        class="BgSidebarDropdown__items BgSidebarDropdown__link"
        v-for="item in filteredItems"
        :key="item.id"
        @click.native="hideClick"
        :to="item.path"
      >
        <div class="BgSidebarDropdown__link-text">{{ item.label }}</div>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>

export default {
  name: "BgSidebarDropdown",
  components: {},
  props: {
    location: String,
    items: Array,
    top: Boolean,
    searchEnabled: {
      type: Boolean,
      default: false,
    },
    hideClick: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    toLink() {
      return this.$route.path.includes("research") ? "/research" : "/tests";
    },
    filteredItems() {
      if (!this.searchEnabled) {
        return this.items;
      }
      const query = this.search.toLowerCase();
      return this.items.filter((item) =>
        String(item.label).toLowerCase().includes(query)
      );
    },
  },
};
</script>
